import {
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Drawer,
  Form,
  message,
  Row,
  Select,
  Space,
  Spin,
  Tooltip,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import { ReactComponent as Edit } from "../../../assests/edit-icon.svg";
import { ReactComponent as Delete } from "../../../assests/delete_icon.svg";
import { ReactComponent as NoteIcon } from "../../../assests/note-pad.svg";
import filtersmultiple from "../../../assests/filtersmultiple.svg";
import locationicon from "../../../assests/locationimage.svg";
import filterIcon from "../../../assests/filterIcon.svg";
import vectorIcon from "../../../assests/Vector.svg";
import checkIcon from "../../../assests/checkIcon.svg";
import awarenessIcon from "../../../assests/awarenessIcon.svg";
import digitalImage from "../../../assests/Image (Times Square Digital Billboard).svg";
import rightIcon from "../../../assests/rightIcon.svg";
import rightArrow from "../../../assests/rightArrow.svg";
import signalIcon from "../../../assests/signalIcon.svg";
import monitorIcon from "../../../assests/monitorIcon.png";
import calendarIcon from "../../../assests/calendaricon.svg";
import aiIcon from "../../../assests/aiIcon.svg";
import deleteIcon from "../../../assests/deleteIcon.svg";
import fileIcon from "../../../assests/fileImage.svg";
import React, { useEffect, useMemo, useState } from "react";
import "./CartCampaigns.css";
import { useDispatch, useSelector } from "react-redux";
import {
  cartDetails,
  deleteTermsFromCheckOut,
  renameCampaignName,
  updateCheckedUnCheckedCart,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { useNavigate } from "react-router-dom";
import DeleteCamapign from "../../modal/delete-campaign/DeleteCampaign";
import { useMediaQuery } from "react-responsive";
import {
  EllipsisOutlined,
  SearchOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";

import FloatingInput from "../float-input/FloatInput";
import { formatToUSCurrency, handleCopy } from "../utils/Utils";
import { ReactComponent as Warning } from "../../../assests/emojione_warning.svg";
import EmptyViewCard from "../../../components/common/empty-view-card/EmptyViewCard";
import {
  addBreadcrumb,
  setBreadcrumbs,
} from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import CustomTermsModal from "../../modal/checkout-page-modal/CustomTermsModal";
import "../../../styles/cartCampaigns.css";
import Input from "antd/es/input/Input";
import { API_BASE_URL_IMAGE } from "../../../services/common";
const CampaignsCart = (userRole) => {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [editValue, setEditValue] = useState("");
  const [renameDraw, setRenameDraw] = useState(false);
  const [deleteCampaignId, setDeleteCampaignId] = useState();
  const [deleteProductId, setDeleteProductId] = useState({
    id: null,
    product_id: null,
    price: null,
  });
  const [type, setType] = useState("");
  const [selectedCampaign, setSelectedCampaign] = useState();
  const [actionItemsDraw, setActionItemDraw] = useState(false);
  const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);
  const [isCampaignExpired, setIsCampaignExpired] = useState(false);
  const {
    campaignCartDetails,
    isLoading: updatesLoading,
    isCartLoading,
    checkedStatus,
  } = useSelector((state) => state?.campaignscart);
  const { isDeleting } = useSelector((state) => state.buyerCampaigns);
  const { isLoading: isTermsLoading } = useSelector(
    (state) => state?.termsCampaign,
  );
  const breadcrumbs = useSelector((state) => state.breadcrumb);
  const [checkedState, setCheckedState] = useState({});
  const [customTermsArray, setCustomTermsArray] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [termsRequest, setTermsRequest] = useState(false);
  const [expiredProducts, setExpiredProducts] = useState(0);
  const smallscreen = useMediaQuery({ maxWidth: 768.99 });
  const response = campaignCartDetails;
  const [selectedType, setSelectedType] = useState("all");
  const [searchTitle, setSearchTitle] = useState("");
  const [sortOrder, setSortOrder] = useState("default");
  const handleViewCampaignDetails = (campaignId) => {
    navigate(
      `/buyer/campaigndetails?_id=${btoa(
        campaignId || selectedCampaign?.campaignId,
      )}`,
    );
  };
  const goToSubPage = ({ title, path }) => {
    dispatch(addBreadcrumb({ title, path }));
  };

  const handlegoToSubPage = ({ title, path }) => {
    const updatedCrumbs =
      breadcrumbs &&
      breadcrumbs?.filter((crumb) => !/^[a-z0-9]{8,}$/i.test(crumb.path));
    // Add Cart crumb
    updatedCrumbs.push({
      title,
      path,
    });
    dispatch(setBreadcrumbs(updatedCrumbs));
  };

  const formatDate = (inputDate) => {
    if (!inputDate) return "Invalid date";
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const parts = inputDate.split("-");
    if (parts.length !== 3) return "Invalid date format";
    const [year, month, day] = parts;
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  };
  const handleActionItemDraw = (campaign) => {
    setSelectedCampaign(campaign);
    setActionItemDraw(true);
  };
  const handleDelete = (
    id,
    product_id,
    price,
    deleteType = "deleteProduct",
  ) => {
    // setDeleteCampaignId(id || selectedCampaign?.product_id);
    setType(deleteType);
    setDeleteCampaignId(id);
    setDeleteProductId({
      id,
      product_id,
      price,
    });
    setDeleteCampaignModal(true);
  };

  const handleSave = () => {
    const array = [...selectedCampaign?.campaignId];
    const payload = {
      campaign_id: array,
      name: editValue,
    };
    dispatch(renameCampaignName(payload));
  };
  const bookings =
    response?.flatMap((campaign) => [
      {
        id: campaign?.id,
        campaignCId: campaign?.campaign?.cid,
        campaignId: campaign?.campaign?.id,
        campaignName: campaign?.campaign?.name,
        startDate: campaign?.from_date,
        endDate: campaign?.to_date,
        totalPrice: campaign?.total_price,
        productBookings: campaign?.product_bookings?.length,
        checkoutChecked: campaign?.checkout_checked,
        campaign_sold_out_status:
          campaign?.campaign_sold_out_status?.sold_status,
        terms_applied_status: campaign?.terms_applied_status,
      },
    ]) || [];
  const handleCheckboxChange = (e, id) => {
    const isChecked = e.target.checked;
    const payload = {
      cart_id: id,
      checked_unchecked: isChecked ? 1 : 0,
    };
    dispatch(updateCheckedUnCheckedCart(payload))
      .then((res) => {
        if (res?.payload?.status == 1) {
          setCheckedState((prev) => ({
            ...prev,
            [id]: isChecked,
          }));
          message.success(res?.payload.message);
        }
      })
      .catch(() => {
        message.error("Something went wrong!");
        // revert state if API failed
        setCheckedState((prev) => ({
          ...prev,
          [id]: !isChecked,
        }));
      });
  };

  const getTooltip = () => {
    if (customTermsArray.length > 0)
      return "This action cannot be performed as custom terms are applied";
  };
  const deleteBtn = (campaign) => (
    <>
      <Delete
        className={`${
          campaign?.terms_applied_status === 1 ? "disable-button" : "pointer"
        } campaign-actions-icons`}
        style={{
          color: campaign?.terms_applied_status === 1 ? "#808080" : "#d2042d",
        }}
      />

      <Text
        className={`${
          campaign?.terms_applied_status === 1
            ? "disable-button"
            : "default-color"
        } campaign-actions`}
      >
        Remove
      </Text>
    </>
  );

  // Handling withdraw terms when there are custom terms for expired products
  const handleRemoveTerms = () => {
    dispatch(deleteTermsFromCheckOut()).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(
          res?.payload?.message || "Terms withdrawn successfully.",
        );
        setTermsRequest(false);
      } else {
        message.error(res?.payload?.message || "Something went wrong.");
      }
      dispatch(cartDetails());
    });
  };

  useEffect(() => {
    if (checkedStatus) {
      dispatch(cartDetails());
    }
  }, [checkedStatus, dispatch]);

  // setting to show withdraw request when there are expired products with terms applied
  useEffect(() => {
    setExpiredProducts(
      bookings?.filter(
        (campaign) =>
          new Date(campaign?.endDate) < new Date() &&
          campaign?.terms_applied_status == 1,
      ).length,
    );
  }, [bookings]);

  useEffect(() => {
    setCustomTermsArray(
      campaignCartDetails?.filter((cart) => cart?.terms_applied_status == 1),
    );
  }, [campaignCartDetails]);
  const selectedCampaignDetails = bookings?.filter(
    (c) => c.checkoutChecked == 1,
  );
  const subtotal = selectedCampaignDetails?.reduce(
    (sum, item) => sum + parseFloat(item?.totalPrice || 0),
    0,
  );

  const refreshData = () => {
    dispatch(cartDetails("campaignCart"));
  };

  useEffect(() => {
    refreshData();
  }, []);
  const proceedToCheckOut = (campaign = null) => {
    goToSubPage({
      title: "Campaign Purchase",
      path: `${userRole === "owner" ? "/seller" : "/buyer"}/campaign-payment`,
    });
    localStorage.setItem("currentStep", 0);
    if (campaign?.campaign_id) {
      const campaignId = encodeURIComponent(String(campaign?.campaign_id));
      navigate(
        `${userRole === "owner" ? "/seller" : "/buyer"}/campaign-payment?campaignId=${campaignId}`,
      );
    } else {
      navigate(
        `${userRole === "owner" ? "/seller" : "/buyer"}/campaign-payment`,
      );
    }
  };
  useEffect(() => {
    if (!bookings) return;
    const today = new Date();
    const flag = bookings.find((campaign) => {
      const endDate = campaign?.endDate ? new Date(campaign.endDate) : null;
      return endDate && endDate < today && campaign?.checkoutChecked === 1;
    });
    setIsCampaignExpired(flag);
  }, [bookings]);
  const today = new Date();
  const formatedDate = (dateValue) => {
    if (!dateValue) return "";
    return new Date(Number(dateValue)).toLocaleDateString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
    });
  };
  const validCampaigns = (campaignCartDetails || []).filter(Boolean);

  const subtotalOfAll = validCampaigns.reduce(
    (total, item) => total + Number(item?.total_price || 0),
    0,
  );
  const filteredCampaigns = useMemo(() => {
    let data = campaignCartDetails
      ?.filter(Boolean)
      ?.map((campaign) => {
        const bookings = campaign?.product_bookings
          ?.filter(Boolean)
          ?.filter((booking) => {
            const typeMatch =
              selectedType === "all" ||
              booking?.product_details?.type?.toLowerCase() ===
                selectedType?.toLowerCase();

            const titleMatch =
              !searchTitle ||
              booking?.product_details?.title
                ?.toLowerCase()
                ?.includes(searchTitle.toLowerCase());

            return typeMatch && titleMatch;
          });

        return {
          ...campaign,
          product_bookings: bookings,
        };
      })
      ?.filter((campaign) => campaign?.product_bookings?.length > 0);

    // Sort CAMPAIGNS
    if (sortOrder === "start-date-asc") {
      data?.sort((a, b) => {
        const dateA = Number(
          a?.product_bookings?.[0]?.from_date?.$date?.$numberLong || 0,
        );

        const dateB = Number(
          b?.product_bookings?.[0]?.from_date?.$date?.$numberLong || 0,
        );

        return dateA - dateB;
      });
    }

    if (sortOrder === "start-date-desc") {
      data?.sort((a, b) => {
        const dateA = Number(
          a?.product_bookings?.[0]?.from_date?.$date?.$numberLong || 0,
        );

        const dateB = Number(
          b?.product_bookings?.[0]?.from_date?.$date?.$numberLong || 0,
        );

        return dateB - dateA;
      });
    }

    if (sortOrder === "price-low-high") {
      data?.sort(
        (a, b) => Number(a?.total_price || 0) - Number(b?.total_price || 0),
      );
    }

    if (sortOrder === "price-high-low") {
      data?.sort(
        (a, b) => Number(b?.total_price || 0) - Number(a?.total_price || 0),
      );
    }

    return data || [];
  }, [campaignCartDetails, selectedType, searchTitle, sortOrder]);
  const isExpired = campaignCartDetails?.some((item) =>
    item?.product_bookings?.some(
      (booking) => Number(booking?.expired_status) === 1,
    ),
  );

  const isSoldOut = campaignCartDetails?.some(
    (item) => Number(item?.campaign_sold_out_status?.sold_status) === 1,
  );
  return (
    <>
      <div className="cart-details-section">
        <div className="cart-details-section-inner-div">
          <div style={{ width: "100%" }}>
            <Card className="search-filters-details">
              <div className="search-filters">
                <Input
                  className="asset-search"
                  placeholder="Search assets..."
                  prefix={<SearchOutlined />}
                  value={searchTitle}
                  allowClear
                  onChange={(e) => setSearchTitle(e.target.value)}
                  // value={searchValue}
                  // onChange={(e) => setSearchValue(e.target.value)}
                />
                <div className="type-buttons">
                  <img
                    src={filterIcon}
                    alt="filter-icon"
                    className="filterIcon"
                  />
                  <Button
                    className={`allTypeButton ${selectedType === "all" ? "selected" : ""}`}
                    onClick={() => setSelectedType("all")}
                  >
                    All Types
                  </Button>

                  <Button
                    className={`digitalButton ${selectedType === "digital" ? "selected" : ""}`}
                    onClick={() => setSelectedType("digital")}
                  >
                    Digital
                  </Button>

                  <Button
                    className={`staticButton ${selectedType === "static" ? "selected" : ""}`}
                    onClick={() => setSelectedType("static")}
                  >
                    Static
                  </Button>
                  <img
                    src={filtersmultiple}
                    alt="Filters-icon"
                    className="filterIcon"
                  />
                  <Select
                    value={sortOrder}
                    onChange={(value) => setSortOrder(value)}
                    defaultValue="default"
                    className="default-order-select"
                    popupClassName="default-order-dropdown"
                    classNames={{
                      popup: {
                        root: "default-order-dropdown",
                      },
                    }}
                    style={{ fontSize: "12px" }}
                    options={[
                      {
                        value: "default",
                        label: "Default order",
                      },
                      {
                        value: "price-low-high",
                        label: "Price: Low → High",
                      },
                      {
                        value: "price-high-low",
                        label: "Price: High → Low",
                      },
                      {
                        value: "start-date-asc",
                        label: "Start Date ↑",
                      },
                      {
                        value: "end-date-desc",
                        label: "End Date ↓",
                      },
                    ]}
                  />
                </div>
              </div>
            </Card>
            <Row
              gutter={[24, 24]}
              style={{
                justifyContent: bookings?.length === 0 && "center",
                display: "block",
                marginTop: "24px",
                marginBottom: "24px",
              }}
            >
              {filteredCampaigns?.filter(Boolean)?.length > 0 ? (
                <>
                  <Col xl={17} md={16} sm={24} className="cart-details-card">
                    {filteredCampaigns?.filter(Boolean)?.length > 0 &&
                      filteredCampaigns?.filter(Boolean)?.map(
                        (campaign, index) => (
                          // smallscreen ? (
                          //   <Card key={index}>
                          //     {campaign?.endDate &&
                          //       new Date(campaign?.endDate) < today && (
                          //         <div className="badge">
                          //           <Text className="expired-ribbon-text">Expired</Text>
                          //         </div>
                          //       )}
                          //     <Row className="cart-summary-version-row">
                          //       <Col className="check-box-cart" sm={2} xs={2}>
                          //         {customTermsArray.length >= 1 ? (
                          //           <Tooltip title={getTooltip()}>
                          //             <Checkbox
                          //               disabled
                          //               checked={
                          //                 campaign?.checkoutChecked === 1 ? true : false
                          //               }
                          //               className="cart-summary-check-box"
                          //             />
                          //           </Tooltip>
                          //         ) : (
                          //           <Checkbox
                          //             checked={
                          //               checkedState[campaign?.id] ??
                          //               (campaign?.checkoutChecked === 1 ? true : false)
                          //             }
                          //             onChange={(e) => {
                          //               handleCheckboxChange(e, campaign?.id);
                          //             }}
                          //             className="cart-summary-check-box"
                          //           />
                          //         )}
                          //       </Col>
                          //       <Col span={22} className="cart-details-version-col">
                          //         <Row gutter={[26, 26]}>
                          //           <Col span={16}>
                          //             <Text className="card-campaign-titles">
                          //               {/* Campaign ID */}
                          //             </Text>
                          //             <br />

                          //             <Text className="card-campaign-text">
                          //               {campaign?.campaignCId || "-"}
                          //             </Text>
                          //           </Col>
                          //           <Col
                          //             span={8}
                          //             className="total-price-col-cart-campaign"
                          //           >
                          //             <Text className="card-campaign-titles">
                          //               Total Price
                          //             </Text>
                          //             <br />
                          //             <Text className="card-campaign-price-text">
                          //               {formatToUSCurrency(
                          //                 parseFloat(campaign?.totalPrice || 0).toFixed(
                          //                   2,
                          //                 ),
                          //               )}
                          //             </Text>
                          //           </Col>
                          //         </Row>
                          //         <Row gutter={[26, 26]}>
                          //           <Col>
                          //             <Text className="card-campaign-titles">
                          //               Campaign Name
                          //             </Text>
                          //             <br />
                          //             <Tooltip title={campaign?.campaignName}>
                          //               <Text className="card-campaign-text truncate">
                          //                 {campaign?.campaignName || "-"}
                          //               </Text>
                          //             </Tooltip>
                          //           </Col>
                          //         </Row>
                          //         <Row gutter={[26, 26]}>
                          //           <Col span={14} sm={16}>
                          //             <Text className="card-campaign-titles">
                          //               Start Date
                          //             </Text>
                          //             <br />
                          //             <Text className="card-campaign-text">
                          //               {formatDate(campaign?.startDate)}
                          //             </Text>
                          //           </Col>
                          //           <Col span={10} sm={8}>
                          //             <Text className="card-campaign-titles">
                          //               End Date
                          //             </Text>
                          //             <br />
                          //             <Text className="card-campaign-text">
                          //               {formatDate(campaign?.endDate)}
                          //             </Text>
                          //           </Col>
                          //         </Row>
                          //         <Row gutter={[26, 36]}>
                          //           <Col span={18}>
                          //             <Row className="number-of-products-cart-campaign-row">
                          //               <Text className="card-campaign-titles">
                          //                 No.of Products
                          //               </Text>
                          //               {campaign?.campaign_sold_out_status
                          //                 ?.sold_status === 1 && (
                          //                   <Tooltip
                          //                     title={
                          //                       <span className="custom-tooltip-inner">
                          //                         Some products are already sold and
                          //                         cannot be proceed....
                          //                       </span>
                          //                     }
                          //                     color="#fff"
                          //                   >
                          //                     <Warning className="cart-campaign-warning-icon-version" />
                          //                   </Tooltip>
                          //                 )}
                          //             </Row>
                          //             <Text className="card-campaign-text">
                          //               {campaign?.productBookings || "-"}
                          //             </Text>
                          //           </Col>
                          //           <Col span={6}>
                          //             <Button
                          //               className="ellipsis-mobile-btn"
                          //               onClick={() => handleActionItemDraw(campaign)}
                          //             >
                          //               <EllipsisOutlined
                          //                 className="rotate-ellipsis"
                          //                 style={{ fontSize: 25 }}
                          //               />
                          //             </Button>
                          //           </Col>
                          //         </Row>
                          //       </Col>
                          //     </Row>
                          //   </Card>
                          // ) : (
                          <Card key={index} className="check-box-campaigns">
                            {/* {campaign?.endDate &&
                          new Date(campaign?.endDate) < today && (
                            <div className="badge">
                              <Text className="expired-ribbon-text">Expired</Text>
                            </div>
                          )} */}
                            <Row align="middle">
                              <Col className="brand-awareness-col">
                                <div className="brandAwernessCol">
                                  <div className="brand-awareness">
                                    <div>
                                      <img
                                        src={awarenessIcon}
                                        alt="brand-awareness"
                                      />
                                      <Text className="brandAwareness">
                                        {campaign?.campaign?.name}
                                      </Text>
                                    </div>
                                    <div className="re-designed-cart-brand-awareness">
                                      <div className="cart-remove-from-cart">
                                        <ShoppingCartOutlined
                                          style={{
                                            color: "#d2042d",
                                            cursor: "pointer",
                                          }}
                                          width={16}
                                        />
                                        <Text
                                          className="remove-campaign-text"
                                          onClick={() => {
                                            handleDelete(
                                              campaign?.campaign_id,
                                              null,
                                              null,
                                              "deleteCampaign",
                                            );
                                          }}
                                        >
                                          {" "}
                                          Remove from Cart
                                        </Text>
                                      </div>
                                      <Text className="brandAwareness-total">
                                        Total
                                      </Text>
                                    </div>
                                  </div>
                                  <div className="brandAwareness-assets">
                                    <Text className="brandAwareness-assets">
                                      {campaign?.product_bookings?.length || 0}{" "}
                                      assets
                                    </Text>
                                    <Text className="brandAwareness-price">
                                      ${campaign?.total_price}
                                    </Text>
                                  </div>
                                </div>
                              </Col>
                              {campaign?.product_bookings?.length > 0 &&
                                campaign?.product_bookings?.map(
                                  (booking, bookingIndex) => (
                                    <>
                                      <Col
                                        flex="auto"
                                        className="digital-cardcampaign-row asset-row"
                                      >
                                        <img
                                          src={
                                            booking?.product_details?.image?.[0]
                                              ? `${API_BASE_URL_IMAGE}${booking.product_details.image[0]}`
                                              : digitalImage
                                          }
                                          alt={
                                            booking?.product_details?.title ||
                                            "product"
                                          }
                                          className="digital-image"
                                        />

                                        <div className="digital-content">
                                          <div className="digital-contnet-inner">
                                            <Text className="card-titles">
                                              {booking?.product_details?.title}
                                            </Text>
                                            <CopyOutlined
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleCopy(
                                                  booking?.product_details
                                                    ?.title,
                                                );
                                              }}
                                              className="copy-icon"
                                            />
                                            {booking?.expired_status === 1 && (
                                              <Button
                                                className="digital-type"
                                                style={{ color: "red" }}
                                              >
                                                Expired
                                              </Button>
                                            )}
                                            {booking?.sold_out_status
                                              ?.sold_status === 1 && (
                                              <Button
                                                className="digital-type"
                                                style={{ color: "red" }}
                                              >
                                                Sold Out
                                              </Button>
                                            )}
                                          </div>
                                          <div className="digital-details">
                                            <Text className="asset-code">
                                              {booking?.product_details?.siteNo}
                                            </Text>
                                            <Button className="digital-type">
                                              {booking?.product_details?.type}
                                            </Button>
                                          </div>
                                          <div className="digital-details-location digital-location-mobile">
                                            <div className="digital-location-div">
                                              <img
                                                src={locationicon}
                                                alt="locationicon"
                                                className="location-image"
                                              />
                                              <Text className="location-text">
                                                {
                                                  booking?.product_details
                                                    ?.city_name
                                                }
                                              </Text>
                                            </div>
                                            <div className="digital-location-div">
                                              <img
                                                src={calendarIcon}
                                                alt="calendarIcon"
                                              />
                                              <Text className="date-css">
                                                {formatedDate(
                                                  booking?.product_details
                                                    ?.from_date?.$date
                                                    ?.$numberLong,
                                                )}
                                                {" – "}
                                                {formatedDate(
                                                  booking?.product_details
                                                    ?.to_date?.$date
                                                    ?.$numberLong,
                                                )}
                                              </Text>
                                            </div>
                                            <div className="digital-location-div">
                                              <img
                                                src={monitorIcon}
                                                alt="calendarIcon"
                                              />
                                              <Text className="date-css">
                                                {
                                                  booking?.product_details
                                                    ?.panelSize
                                                }
                                              </Text>
                                            </div>
                                            <div className="digital-location-div">
                                              <img
                                                src={signalIcon}
                                                alt="calendarIcon"
                                              />
                                              <Text className="date-css">
                                                {
                                                  booking?.product_details
                                                    ?.secondImpression
                                                }
                                              </Text>
                                            </div>
                                          </div>
                                          <Tooltip
                                            title={
                                              campaign?.offer_disable === 1
                                                ? "You can't perform this action when the offer is applied"
                                                : ""
                                            }
                                          >
                                            <div className="digital-details-location digital-location-mobile-second-div">
                                              <div
                                                className="digital-location-div"
                                                style={{
                                                  cursor:
                                                    campaign?.offer_disable !==
                                                    1
                                                      ? "pointer"
                                                      : "",
                                                }}
                                                onClick={() => {
                                                  if (
                                                    campaign?.offer_disable ===
                                                    1
                                                  )
                                                    return;

                                                  handleDelete(
                                                    campaign?.campaign_id,
                                                    booking?.product_id,
                                                    booking?.offerpriceperselectedDates,
                                                  );
                                                }}
                                              >
                                                <img
                                                  src={deleteIcon}
                                                  alt="delete"
                                                  className={`location-image ${
                                                    campaign?.offer_disable ===
                                                    1
                                                      ? "disabled-opacity"
                                                      : ""
                                                  }`}
                                                />

                                                <Text
                                                  className={`location-text ${
                                                    campaign?.offer_disable ===
                                                    1
                                                      ? "disabled-opacity"
                                                      : ""
                                                  }`}
                                                >
                                                  Remove
                                                </Text>
                                              </div>
                                            </div>
                                          </Tooltip>
                                        </div>

                                        <Text className="bill-board-price">
                                          ${booking?.offerpriceperselectedDates}
                                        </Text>
                                      </Col>
                                      <div className=" digital-location-move-delete-mobile">
                                        <div
                                          className={`digital-location-div-mobile ${campaign?.offer_disable === 1 ? "disabled-opacity" : ""}`}
                                          style={{
                                            cursor:
                                              campaign?.offer_disable !== 1
                                                ? "pointer"
                                                : "",
                                          }}
                                          onClick={() => {
                                            console.log(`campaign`, campaign);
                                            if (campaign?.offer_disable === 1) {
                                              return;
                                            }
                                            handleDelete(
                                              campaign?.campaign_id,
                                              booking?.id,
                                              booking?.price,
                                            );
                                          }}
                                        >
                                          <img
                                            src={deleteIcon}
                                            alt="delete"
                                            className={`location-image ${campaign?.offer_disable === 1 ? "disabled-opacity" : ""}`}
                                          />
                                          <Text
                                            className={`location-text ${campaign?.offer_disable === 1 ? "disabled-opacity" : ""}`}
                                          >
                                            Remove
                                          </Text>
                                        </div>
                                      </div>
                                    </>
                                  ),
                                )}

                              <Col className="Ai-review-sign-col">
                                <div className="Ai-review-sign-div">
                                  {/* <Button className="Ai-review-sign">
                                <img src={aiIcon} alt="brand-awareness" />
                                <Text className="Ai-review-sign-text">AI Suggest</Text>
                              </Button>

                              <Button className="Ai-review-sign">
                                <img src={fileIcon} alt="brand-awareness" />
                                <Text className="Ai-review-sign-text">Submit RFP</Text>
                              </Button> */}

                                  <Button
                                    className={`Ai-review-sign reviw-sign-button ${campaign?.campaign_purchase_disable == 1 ? "disabled-opacity" : ""}`}
                                    disabled={
                                      campaign?.campaign_purchase_disable == 1
                                    }
                                    onClick={() => proceedToCheckOut(campaign)}
                                  >
                                    <Text className="review-sign-text">
                                      Review & Sign
                                    </Text>
                                    <img
                                      src={rightIcon}
                                      alt="brand-awareness"
                                    />
                                  </Button>
                                </div>
                              </Col>

                              {/* <Col xl={6} lg={5} md={11} sm={8}>
                                  <Text className="card-campaign-titles">
                                    Start Date
                                  </Text>
                                  <br />
                                  <Text className="card-campaign-text">
                                    {formatDate(campaign?.startDate)}
                                  </Text>
                                </Col> */}
                              {/* <Col
                                  xl={8}
                                  md={13}
                                  lg={7}
                                  className="number-of-products-cart-campaign-col"
                                >
                                  <Row className="number-of-products-cart-campaign-row">
                                    <Col>
                                      <Text className="card-campaign-titles">
                                        No.of Products
                                      </Text>
                                    </Col>
                                    {campaign?.campaign_sold_out_status === 1 && (
                                      <Tooltip
                                        title={
                                          <span className="custom-tooltip-inner">
                                            Some products are already sold and
                                            cannot be proceed....
                                          </span>
                                        }
                                        color="#fff"
                                      >
                                        <Warning className="cart-campaign-warning-icon" />
                                      </Tooltip>
                                    )}
                                  </Row>
                                  <Text className="card-campaign-text">
                                    {campaign?.productBookings || "-"}
                                  </Text>
                                </Col>
                                <Col xl={4} lg={4} md={11}>
                                  <Text className="card-campaign-titles">
                                    Total Price
                                  </Text>
                                  <br />
                                  <Text className="card-campaign-price-text">
                                    {formatToUSCurrency(
                                      parseFloat(campaign?.totalPrice || 0).toFixed(
                                        2,
                                      ),
                                    )}
                                  </Text>
                                </Col> */}
                              {/* <Row style={{ marginTop: 29 }}>
                                <Col xl={6} lg={9} md={13}>
                                  <Text className="card-campaign-titles">
                                    Campaign Name
                                  </Text>
                                  <br />
                                  <div className="product-copy-text-field">
                                    <Tooltip title={campaign?.campaignName}>
                                      <Text className="card-campaign-text truncate">
                                        {campaign?.campaignName || "-"}
                                      </Text>
                                    </Tooltip>
                                    <CopyOutlined
                                      onClick={(e) => {
                                        e.stopPropagation(); // prevent tooltip close
                                        handleCopy(campaign?.campaignName);
                                      }}
                                      className="copy-icon"
                                    />
                                  </div>
                                </Col>
                                <Col xl={7} lg={6} md={11}>
                                  <Text className="card-campaign-titles">
                                    End Date
                                  </Text>
                                  <br />
                                  <Text className="card-campaign-text">
                                    {formatDate(campaign?.endDate)}
                                  </Text>
                                </Col>
                                <Col
                                  xl={11}
                                  lg={24}
                                  className="card-campaign-actions-col"
                                >
                                  <div
                                    onClick={() => {
                                      handlegoToSubPage({
                                        title: campaign?.campaignName,
                                        path: `/buyer/campaigndetails?_id=${btoa(
                                          campaign?.campaignId ||
                                          selectedCampaign?.campaignId,
                                        )}`,
                                      });
                                      navigate(
                                        `/buyer/campaigndetails?_id=${btoa(
                                          campaign?.campaignId,
                                        )}`,
                                      );
                                    }}
                                    className="campaign-actions-container"
                                  >
                                    <Edit className="campaign-actions-icons pointer" />
                                    <Text className="campaign-actions default-color">
                                      Edit
                                    </Text>
                                  </div>
                                  <Divider type="vertical" />

                                  <div
                                    onClick={(event) => {
                                      if (campaign?.terms_applied_status == 1) {
                                        event.preventDefault();
                                        return;
                                      }
                                      handleDelete(campaign?.campaignId);
                                    }}
                                    className="campaign-actions-container"
                                  >
                                    <Tooltip
                                      title={
                                        campaign?.terms_applied_status == 1
                                          ? getTooltip()
                                          : ""
                                      }
                                    >
                                      {deleteBtn(campaign)}
                                    </Tooltip>
                                  </div>

                                  <Divider type="vertical" />
                                  <div
                                    onClick={() => {
                                      handlegoToSubPage({
                                        title: campaign?.campaignName,
                                        path: `/buyer/campaigndetails?_id=${btoa(
                                          campaign?.campaignId ||
                                          selectedCampaign?.campaignId,
                                        )}`,
                                      });
                                      handleViewCampaignDetails(
                                        campaign?.campaignId,
                                      );
                                    }}
                                    className="campaign-actions-container"
                                  >
                                    <NoteIcon className="campaign-actions-icons pointer" />
                                    <Text className="campaign-actions default-color">
                                      {" "}
                                      View Details
                                    </Text>
                                  </div>
                                </Col>
                              </Row> */}
                            </Row>
                          </Card>
                        ),
                        //   ),
                      )}
                    <Button
                      type="dashed"
                      className="dashed_button"
                      onClick={() => {
                        navigate("/buyer/products");
                      }}
                    >
                      <Text className="create_campaign_text_dashed_button_text">
                        + Create New Campaign
                      </Text>
                    </Button>
                  </Col>
                </>
              ) : (
                <div>
                  <EmptyViewCard
                    header={"Campaigns added..."}
                    text={
                      "Browse available campaigns and add them to your cart to start planning your strategy."
                    }
                  />
                </div>
              )}

              {/*  Withdraw terms modal */}
              <CustomTermsModal
                termsRequest={termsRequest}
                setTermsRequest={setTermsRequest}
                handleRemoveTerms={handleRemoveTerms}
                modalType={modalType}
                isExpired={true}
              />
              <DeleteCamapign
                deleteCampaignId={deleteCampaignId}
                deleteProductId={deleteProductId}
                setDeleteCampaignModal={setDeleteCampaignModal}
                deleteCampaignModal={deleteCampaignModal}
                selectedCampaignPage={false}
                buttonText={`remove`}
                type={type}
              />
              <Drawer
                size="default"
                placement="bottom"
                closable={false}
                onClose={() => setActionItemDraw(false)}
                open={actionItemsDraw}
              >
                <div className="card-campaign-actions-div">
                  <Space direction="vertical" size={20}>
                    <Row>
                      <Text
                        className="card-campaign-actions-div-text"
                        onClick={() => {
                          setRenameDraw(true);
                          setActionItemDraw(false);
                        }}
                      >
                        Edit Campaign
                      </Text>
                    </Row>
                    <Row>
                      <Text
                        className={` ${
                          selectedCampaign?.terms_applied_status === 1
                            ? "disable-button"
                            : "card-campaign-actions-div-text"
                        }`}
                        onClick={(event) => {
                          if (selectedCampaign?.terms_applied_status == 1) {
                            event.preventDefault();
                            setActionItemDraw(true);
                            return;
                          } else {
                            handleDelete(selectedCampaign?.campaignId);
                            setActionItemDraw(true);
                          }
                        }}
                      >
                        <Tooltip
                          title={
                            selectedCampaign?.terms_applied_status === 1
                              ? getTooltip()
                              : ""
                          }
                        >
                          Remove
                        </Tooltip>
                      </Text>
                    </Row>
                    <Row onClick={() => handleViewCampaignDetails()}>
                      <Text className="card-campaign-actions-div-text">
                        View Details
                      </Text>
                    </Row>
                  </Space>
                </div>
              </Drawer>
              <Drawer
                size="default"
                placement="bottom"
                closable={false}
                onClose={() => setRenameDraw(false)}
                open={renameDraw}
              >
                <div className="rename-draw-container">
                  <Row>
                    <Text className="rename-draw-header"> Rename</Text>
                  </Row>
                  <Form>
                    <Form.Item name="campaignname">
                      <Row style={{ marginTop: 40 }}>
                        <FloatingInput
                          label="Enter new campaign name..."
                          className="campaign-input-field"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                        />
                      </Row>
                    </Form.Item>
                    <Row justify="space-evenly">
                      <Button
                        onClick={() => setRenameDraw(false)}
                        className="handle-rename-cancel-btn"
                      >
                        Cancel
                      </Button>
                      <Button
                        className="handle-rename-save-btn"
                        onClick={handleSave}
                      >
                        Save
                      </Button>
                    </Row>
                  </Form>
                </div>
              </Drawer>
            </Row>
          </div>
          {campaignCartDetails?.filter(Boolean)?.length > 0 && (
            <Col xl={7} md={8} xs={24} className="proceed-to-check-out-col">
              <Card className="cart-summary-card" bordered={false}>
                {/* Header */}
                <div className="cart-summary-header">
                  <Text className="cart-summary-txt">Cart Summary</Text>
                  <Text className="cart-summary-assets">
                    {campaignCartDetails?.filter(Boolean)?.length || 0}{" "}
                    campaigns ·{" "}
                    {campaignCartDetails
                      ?.filter(Boolean)
                      ?.reduce(
                        (total, campaign) =>
                          total + (campaign?.product_bookings?.length || 0),
                        0,
                      )}{" "}
                    assests
                  </Text>
                </div>

                <div className="cart-summary-content">
                  {campaignCartDetails?.filter(Boolean)?.length > 0 &&
                    campaignCartDetails?.filter(Boolean)?.map((item) => {
                      const isExpired = item?.product_bookings?.some(
                        (booking) => Number(booking?.expired_status) === 1,
                      );

                      const isSoldOut =
                        Number(item?.campaign_sold_out_status?.sold_status) ===
                        1;

                      return (
                        <>
                          <div className="cart-campaigns-list">
                            <div className="campaign-row">
                              <div className="campaign-details">
                                <Text className="campaign-name">
                                  {item?.campaign?.name}
                                </Text>
                                <Text className="campaign-assets">
                                  {item?.product_bookings?.length || 0} assets
                                </Text>
                                {isExpired && (
                                  <Button
                                    className="digital-type"
                                    style={{ color: "red" }}
                                  >
                                    Expired
                                  </Button>
                                )}
                                {isSoldOut && (
                                  <Button
                                    className="digital-type"
                                    style={{ color: "red" }}
                                  >
                                    Sold Out
                                  </Button>
                                )}
                              </div>
                              <div className="campaign-price">
                                ${item?.total_price}
                              </div>
                            </div>
                          </div>
                          <div className="cart-divider"></div>
                        </>
                      );
                    })}
                  {/* Total */}
                  <div className="estimated-total-row">
                    <Text className="estimated-total">Est. Total</Text>
                    <strong className="estimated-total-price">
                      ${subtotalOfAll}
                    </strong>
                  </div>
                </div>
                <div className="cart-summary-buttons">
                  <Button
                    type="primary"
                    className="proceed-to-checkout review-sign-button"
                    onClick={proceedToCheckOut}
                  >
                    <Text className="review-sign-button-text">
                      Review &amp; Sign IO
                      <img src={vectorIcon} alt="arrow" />
                    </Text>
                  </Button>

                  {/* Continue Shopping */}
                  <Button
                    className="continue-shopping-button"
                    onClick={() => {
                      navigate("/buyer/Products");
                    }}
                  >
                    Continue Shopping
                  </Button>
                </div>
                {/* Main Button */}

                {/* Benefits */}
                <div className="cart-benefits">
                  <Text className="cart-benefits-text">
                    <img src={checkIcon} alt="check" /> Negotiate directly with
                    sellers
                  </Text>
                  <Text className="cart-benefits-text">
                    <img src={checkIcon} alt="check" /> Accept or reject per
                    product
                  </Text>
                  <Text className="cart-benefits-text">
                    <img src={checkIcon} alt="check" />
                    Flexible payment terms
                  </Text>
                  <Text className="cart-benefits-text">
                    <img src={checkIcon} alt="check" />
                    DocuSign-secured contracts
                  </Text>
                </div>
              </Card>
            </Col>
          )}
        </div>
        {(updatesLoading || isCartLoading || isTermsLoading || isDeleting) && (
          <div className="loading-css">
            <Spin fullscreen />
          </div>
        )}
      </div>
      {/* {smallscreen && (
        <Col xl={7} md={8} xs={28} className="proceed-to-check-out-col">
          <Card className="checkout-card">
            {selectedCampaignDetails?.length > 0 ? (
              <Row className="check-out-version-bottom-card">
                <Text className="card-campaign-total">
                  You've selected a total of ({""}
                  <span className="number-of-campaigns-collected">
                    {selectedCampaignDetails?.length}
                    {"-"}
                    Campaigns)
                  </span>
                </Text>
              </Row>
            ) : (
              <Row className="check-out-version-bottom-card">
                <Text className="card-campaign-total">
                  To proceed with checkout, please select at least one campaign.
                </Text>
              </Row>
            )}
            {selectedCampaignDetails?.length > 0 ? (
              <Row className="checkout-total-button-row">
                <Col className="cart-sub-total-price-version-col" xs={8}>
                  <Text className="card-campaign-total">Subtotal</Text>
                  <Text className="cart-sub-total-price-version">
                    {" "}
                    {formatToUSCurrency(Number(subtotal)?.toFixed(2))}
                  </Text>
                </Col>
                <Col xs={12}>
                  <Button
                    type="primary"
                    className={`proceed-to-checkout ${isCampaignExpired || selectedCampaignDetails?.length <= 0
                      ? "disabled-opacity"
                      : ""
                      }`}
                    onClick={proceedToCheckOut}
                  >
                    Proceed to Checkout
                  </Button>
                  {expiredProducts >= 1 && (
                    <Text
                      className="request-still-wating-text"
                      onClick={() => {
                        setModalType("withdraw");
                        setTermsRequest(true);
                      }}
                    >
                      Withdraw the Request
                    </Text>
                  )}
                </Col>
              </Row>
            ) : (
              <Row className="checkout-total-button-row">
                <Button
                  type="primary"
                  className={`proceed-to-checkout ${isCampaignExpired || selectedCampaignDetails?.length <= 0
                    ? "disabled-opacity"
                    : ""
                    }`}
                  onClick={proceedToCheckOut}
                >
                  Proceed to Checkout
                </Button>
                {expiredProducts >= 1 && (
                  <Text
                    className="request-still-wating-text"
                    onClick={() => {
                      setModalType("withdraw");
                      setTermsRequest(true);
                    }}
                  >
                    Withdraw the Request
                  </Text>
                )}
              </Row>
            )}
          </Card>
        </Col>
      )
      } */}
    </>
  );
};

export default CampaignsCart;
